<template>
    <v-card>
        <v-form
            ref="comissionreportForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-card-title>Import Customers</v-card-title>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="sureReps"
                                :rules="[requiredRule]"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="Signed By"
                                v-model="signedBy"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="companies"
                                :rules="[requiredRule]"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="Company"
                                v-model="company"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="representatives"
                                :rules="[requiredRule]"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="Representative"
                                v-model="representative"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="subscriptions"
                                :rules="[requiredRule]"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="Subscription"
                                v-model="subscription"
                            ></v-select>
                        </v-col>

                        <!--<v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="debitOrderDates"
                                :rules="[requiredRule]"
                                clearable
                                item-text="value"
                                item-value="key"
                                label="Debit Order Date"
                                v-model="debitOrderDate"
                            ></v-select>
                        </v-col>-->

                        <v-col cols="12">
                            <v-file-input
                                :disabled="isLoading"
                                accept=".csv"
                                label="Customer Import CSV"
                                placeholder="Select csv file"
                                ref="importdoc"
                                v-model="importDoc"
                            >
                            </v-file-input>
                        </v-col>
                    </v-row>

                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="importCustomers"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Import</v-btn>
                    </v-row>
                </v-container>
               
            </v-card-text>
            <v-btn @click="showChangeList = true" color="primary">
                Show Change List
            </v-btn>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>    
        <v-dialog v-model="showChangeList" max-width="600px">
            <v-card>
                <v-card-title>
                    <h2>Change List</h2>
                </v-card-title>
                <v-card-text>
                    <ul>
                        <li v-for="change in changesList" :key="change">{{ change }}</li>
                    </ul>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="exportToExcel">
                        Export to Excel
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="showChangeList = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
//import dateToString from "../../helpers/dateToString"
import * as XLSX from 'xlsx';
export default {
    data() {
        return {
            isValid: null,
            isLoading: false,
            isSaving: false,
            changesList: [], 
            notifyShow: false,
            notifyMessage: '',
            notifyColor: '',
            signedBy: null,
            company: null,
            representative: null,
            subscription: null,
            debitOrderDate: null,
            importDoc: null,
            sureReps: [],
            representatives: [],
            subscriptions: [],
            debitOrderDates: [],
            companies: [],
            requiredRule: v => !!v || "required",
            requiredRuleNum: v => !!v || v === 0 || "required",
            lengthRule: limit => v => !v || v.length <= limit || "exceeds " + limit + " characters",
            showChangeList: false, 

        };
    },

    created: async function() {
        this.sureReps = await this.$store.dispatch("users/getAccisureReps");
        this.representatives = await this.$store.dispatch("representatives/getlist");
        this.subscriptions = await this.$store.dispatch("subscriptions/getlist");
        this.debitOrderDates = await this.$store.dispatch("customers/getDebitOrderDates");
        this.companies = await this.$store.dispatch("companies/getlist");
    },

    methods: {
        emitCloseForm() {
            this.$emit("close");
        },

        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },

        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },

        validateForm() {
            this.isValid = this.$refs.comissionreportForm.validate();
            return this.isValid;
        },

        importCustomers() {
    if (this.validateForm()) {
        this.isLoading = true;
        this.isSaving = true;

        var formdata = new FormData();
        formdata.append("ImportDoc", this.importDoc);
        formdata.append(
            "Model",
            JSON.stringify({
                signedBy: this.signedBy,
                company: this.company,
                representative: this.representative,
                subscription: this.subscription,
                debitOrderDate: this.debitOrderDate
            })
        );

        this.$store.dispatch("customers/customerimport", formdata)
            .then(response => {
                
               
                
                if (response) {
                    
                    this.changesList = response;

                    
                    this.notify("Success!", "success");
                } else {
                    // Handle the case when response is undefined
                    throw new Error("Invalid response received");
                }
            })
            .catch(error => {
                // Show error message
                this.notify(error.message || "An error occurred", "error");
            })
            .finally(() => {
                // Import done, stop loading indicators
                this.importDone();
            });
    }
},

   
importDone() {
      this.isLoading = false;
      this.isSaving = false;

    },
    exportToExcel() {
      if (this.changesList.length > 0) {
        const parsedChanges = this.changesList.map(change => {
      const regex = /(?:- )?(?:ID: )?(\S+)(?:,\s*)?(?:Name: )?([^,]+)(?:,\s*)?(?:Change: )?(.+)/;
          const match = change.match(regex);
          if (match) {
            return {
              ID: match[1],
              Name: match[2],
              Change: match[3]
            };
          }
          return null;
        }).filter(change => change !== null);

        if (parsedChanges.length > 0) {
          const ws = XLSX.utils.json_to_sheet(parsedChanges);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Changes");
          XLSX.writeFile(wb, "ChangeList.xlsx");
        } else {
          this.notify("No valid changes to export.", "error");
        }
      } else {
        this.notify("No changes to export.", "error");
      }
    }
  }
};
</script>